import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import angular from 'angular'

angular.module('signin', ['singin.service']).controller('SigninCtrl', SigninCtrl)

/** @ngInject */
function SigninCtrl($rootScope, $state, $timeout, SigninService, UserCache) {
  var vm = this
  vm.model = {}
  $rootScope.page = 'login'

  vm.code2fa = null
  vm.token = null
  vm.type = null
  UserCache.remove()

  vm.signin = function () {
    SigninService.signin(vm.model).then(function (data) {
      vm.token = data.results.jwt
      if (
        data.results['2fa-t'] === 1 ||
        data.results['2fa-t'] === 2 ||
        data.results['2fa-t'] === 3 ||
        data.results['2fa-t'] === 4
      ) {
        vm.type = data.results['2fa-t']
        SigninService.send2fa({ type: data.results['2fa-t'] }, data.results.jwt).then(function () {
          $('#modal2fa').modal('show')
        })
      } else {
        afterSign(data)
      }
    })
  }

  vm.verify2fa = function () {
    SigninService.check2fa({ code: vm.code2fa, type: null }, vm.token).then(function (data) {
      afterSign(data)
    })
  }

  function checkPermission(auth) {
    if (auth !== undefined) {
      if (auth.user.admin !== undefined) {
        if (auth.user.admin.k === 2) {
          $rootScope.customerService = true
        } else {
          $rootScope.customerService = false
        }
        $rootScope.admin = true
      } else {
        $rootScope.admin = false
      }
      if (auth.user.admin !== undefined && auth.user.producer === undefined) {
        $rootScope.notProducer = true
      } else {
        $rootScope.notProducer = false
      }

      if (auth.user.producer !== undefined) {
        $rootScope.publishers = [auth.user.producer.pu]
      }
    }
  }

  function afterSign(data) {
    var user = data.results.user
    var permission = localStorage.getItem('permission')
    if (user.producer === undefined && user.admin === undefined) {
      swal('You do not have permission!', '', 'error')
    } else if (user.producer !== undefined && user.admin === undefined) {
      checkPermission(data.results)
      UserCache.set(data.results)
      $state.go('pub.channels')
    } else if (user.producer === undefined && user.admin !== undefined) {
      UserCache.set(data.results)
      checkPermission(data.results)
      $state.go('admin.home')
    } else if (user.producer !== undefined && user.admin !== undefined) {
      UserCache.set(data.results)
      checkPermission(data.results)
      if (permission !== null) {
        if (permission === 'admin') {
          $state.go('admin.home')
        } else {
          $state.go('pub.channels')
        }
      } else {
        $state.go('admin.home')
      }
    }
  }

  var FIREBASE_API_KEY = ''
  var FIREBASE_AUTH_DOMAIN = ''
  var FIREBASE_DOMAIN = ''
  var FIREBASE_APP_ID = ''
  if (
    window.location.href.indexOf('dev') !== -1 ||
    window.location.href.indexOf('localhost') !== -1
  ) {
    FIREBASE_API_KEY = 'AIzaSyBQFCaqO7etlo204IHLqY-OLkzP97dcMeg'
    FIREBASE_AUTH_DOMAIN = 'streetteam-dev.firebaseapp.com'
    FIREBASE_DOMAIN = 'streetteam-dev'
    FIREBASE_APP_ID = '1:1096601494401:web:d4951967effe26ca8e7e80'
  } else {
    FIREBASE_API_KEY = 'AIzaSyBPMUuZc6dicRQpP9UsldHS-HNdfin2uL4'
    FIREBASE_AUTH_DOMAIN = 'streetteam-market.firebaseapp.com'
    FIREBASE_DOMAIN = 'streetteam-market'
    FIREBASE_APP_ID = '1:954732182696:web:84b3eda38c42c5d397969d'
  }

  let app
  if (!firebase.apps.length) {
    app = firebase.initializeApp({
      apiKey: FIREBASE_API_KEY,
      authDomain: FIREBASE_AUTH_DOMAIN,
      projectId: FIREBASE_DOMAIN,
      appID: FIREBASE_APP_ID,
    })
  } else {
    app = firebase.app()
  }

  const providerGoogle = new firebase.auth.GoogleAuthProvider()
  const providerApple = new firebase.auth.OAuthProvider(`apple.com`)
  providerApple.addScope(`email`)
  providerApple.addScope(`name`)

  vm.signInGoogle = function (e) {
    e.preventDefault()
    e.stopPropagation()

    app
      .auth()
      .signInWithPopup(providerGoogle)
      .then(function () {
        app
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ true)
          .then(function (idToken) {
            SigninService.signinGoogle(idToken).then(
              function (data) {
                vm.token = data.results.jwt
                if (
                  data.results['2fa-t'] === 1 ||
                  data.results['2fa-t'] === 2 ||
                  data.results['2fa-t'] === 3 ||
                  data.results['2fa-t'] === 4
                ) {
                  vm.type = data.results['2fa-t']
                  SigninService.send2fa({ type: data.results['2fa-t'] }, data.results.jwt).then(
                    function () {
                      $('#modal2fa').modal('show')
                    },
                  )
                } else {
                  afterSign(data)
                }
              },
              function (err) {
                if (err && err.error) {
                  swal(err.error.message, '', 'error')
                } else {
                  swal('Try again please', '', 'error')
                }
              },
            )
          })
          .catch(function (error) {
            swal(error.message, '', 'error')
          })
      })
      .catch(function (error) {
        swal(error.message, '', 'error')
      })
  }

  vm.signInApple = function (e) {
    e.preventDefault()
    e.stopPropagation()

    app
      .auth()
      .signInWithPopup(providerApple)
      .then(function (result) {
        app
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ true)
          .then(function (idToken) {
            SigninService.signinApple({
              appleId: result.additionalUserInfo.profile.sub,
              firebaseToken: idToken,
              refreshToken: result.user.refreshToken,
            }).then(
              function (data) {
                vm.token = data.results.jwt
                if (
                  data.results['2fa-t'] === 1 ||
                  data.results['2fa-t'] === 2 ||
                  data.results['2fa-t'] === 3 ||
                  data.results['2fa-t'] === 4
                ) {
                  vm.type = data.results['2fa-t']
                  SigninService.send2fa({ type: data.results['2fa-t'] }, data.results.jwt).then(
                    function () {
                      $('#modal2fa').modal('show')
                    },
                  )
                } else {
                  afterSign(data)
                }
              },
              function (err) {
                if (err && err.error) {
                  swal(err.error.message, '', 'error')
                } else {
                  swal('Try again please', '', 'error')
                }
              },
            )
          })
          .catch(function (error) {
            swal(error.message, '', 'error')
          })
      })
      .catch(function (error) {
        swal(error.message, '', 'error')
      })
  }
}
